<script lang="ts">
  import type { DiscountResult } from "@retailer/services/discounts_service";
  import UIRouterLink from "@shared/svelte/Components/UIRouterLink.svelte";
  import Modal from "@shared/svelte/Components/Modal.svelte";
  import Icon from "@shared/svelte/Components/Icon.svelte";
  import FormatMoney from "@shared/svelte/Components/FormatMoney.svelte";
  import { DISCOUNT_AMOUNT_TYPES } from "@shared/types/Deals";

  export let products: any;
  export let distributorName: string;
  export let distributorId: number;

  let showModal: boolean = false;
  let rips: DiscountResult[] = [];

  const distributorApp = window["C"].APP_NAME == "distributor";

  function fetchRips() {
    rips = [];
    products
      .filter(op => !op.deleted)
      .forEach(function (op) {
        op.discounts?.forEach(function (orderProductDiscount) {
          const discount = orderProductDiscount?.discount;
          if (
            discount &&
            discount.amount_type === DISCOUNT_AMOUNT_TYPES.RIP &&
            !rips.some(r => r.id == discount.id)
          ) {
            rips.push(discount);
          }
        });
      });
  }

  function openRipsModal() {
    showModal = true;
  }

  function closeModal() {
    showModal = false;
  }

  $: {
    products = products;
    distributorName = distributorName;
    fetchRips();
  }
</script>

{#if rips.length > 0}
  <p class="fizz-stack-16" />
  <div
    class="align-left fizz-card fizz-inset-squish-16 fizz-text-small fizz-radius-medium"
    style="border: 1px dashed #BFBFBF"
    id="rips-section"
  >
    <p>
      <strong>Items in this order qualify for RIPs</strong>
    </p>
    {#if distributorApp}
      <div class="fizz-stack-4" />
      <p>
        <strong>RIPs ({rips.length})</strong>
      </p>
      <div class="fizz-stack-4" />

      {#each rips as rip}
        <p>
          {rip.deal_tier_name}
          {rip.case_count}
          {rip.deal_tier_label} &ndash; <FormatMoney input={rip.amount} /> RIP
        </p>
      {/each}
    {:else}
      <p>
        Final RIPs will be determined and paid out by {distributorName}.
      </p>
      <p>
        <a
          href={"#"}
          on:click|preventDefault={openRipsModal}
          class="nounderline-hover rips-modal-link">See Details</a
        >
      </p>
    {/if}
  </div>
{/if}

<Modal
  bind:show={showModal}
  closeOnBackgroundClick={true}
  fizzModal={true}
  center={true}
  tiny={true}
>
  <div class="layout-header-footer fizz-stack fizz-flow-16 rips-modal align-left">
    <header class="fizz-modal-header">
      <h4 class="fizz-heading-4">Qualified RIPs for this order</h4>
      <a href={"#"} on:click={closeModal} class="fizz-modal-toggle fizz-modal-close">
        <Icon width="16" height="16" type="X" className="fizz-icon-16 fizz-text-brand" />
      </a>
    </header>
    <section class="fizz-modal-main fizz-text-medium fizz-flow-16">
      <div>
        If you qualify for multiple RIPs for a single product, your distributor will determine the
        final RIP.
        <a
          href="https://support.provi.com/s/article/deals"
          target="_blank"
          rel="noopener noreferrer">Learn more</a
        >.
      </div>

      <div
        class="fizz-card fizz-inset-squish-16 fizz-text-small fizz-radius-medium"
        style="border: 1px dashed #BFBFBF"
        id="rips-section"
      >
        <p>
          <strong>RIPs ({rips.length})</strong>
        </p>
        <div class="fizz-stack-4" />

        {#each rips as rip}
          <p>
            {#if !rip.is_mix_match}
              {rip.deal_tier_name}
              {rip.case_count}
              {rip.deal_tier_label} &ndash; <FormatMoney input={rip.amount} /> RIP
            {:else if rip.product_group_id}
              <UIRouterLink
                stateName="layout.deals_v2"
                params={{
                  distributorId: distributorId,
                  productGroupId: rip.product_group_id,
                }}
                trackingParams={{
                  discountClick: true,
                  product_id: rip.product_id,
                  distributor_id: distributorId,
                  product_group_id: rip.product_group_id,
                  sku: rip.sku,
                }}
              >
                {rip.deal_tier_name}
                {rip.case_count}
                {rip.deal_tier_label}
                &ndash; <FormatMoney input={rip.amount} /> RIP
              </UIRouterLink>
            {:else}
              <UIRouterLink
                stateName="layout.deal_detail"
                params={{ dealId: rip.deal_id, dealTierId: rip.deal_tier_id }}
                trackingParams={{
                  discountClick: true,
                  product_id: rip.product_id,
                  deal_tier_id: rip.deal_tier_id,
                  distributor_id: distributorId,
                  sku: rip.sku,
                }}
              >
                {rip.deal_tier_name}
                {rip.case_count}
                {rip.deal_tier_label}
              </UIRouterLink>
              &ndash; <FormatMoney input={rip.amount} /> RIP
            {/if}
          </p>
        {/each}
      </div>
      <p class="fizz-stack-16" />
    </section>
  </div>
</Modal>
